import SubjectContent from '../shared/SubjectContent';
import { finalDesign } from './finalDesign';

export default function ChoiceContent() {
    return <SubjectContent page="choice" design={finalDesign} />;
}
